


























import Vue, { PropType } from "vue";
import { QuestionsInterface } from "@/model/components/new/QuestionsInterface.ts";
import { validationMixin } from "vuelidate";
import { maxLength } from "vuelidate/lib/validators";

export default Vue.extend({
  name: "Questions",

  mixins: [validationMixin],

  props: {
    questions: {
      type: Object as PropType<QuestionsInterface>
    }
  },

  validations: {
    question: { maxLength: maxLength(500) }
  },

  computed: {
    question(): string {
      return this.questions.question;
    }
  },

  methods: {
    validation(): boolean {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    updateQuestions(value: string): void {
      this.validation();
      this.$emit(
        "updateQuestions",
        Object.assign({}, this.questions, { question: value })
      );
    }
  }
});
